import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjsUtils from '@attain-apps/rxjs-utils'
import * as rxjs from 'rxjs'

import type * as contexts from '../../contexts'
import type * as userAssignment from '../../user-assignment'
import type { TypeParams } from '../types'

/**
 * When assign access mutation succeeds, refresh users list
 */
export const refreshUsersOnAccessAssignmentSuccess = store.effects.create(
  (
    feature: ec.Collection<TypeParams>['feature'],
    usersEc: ec.Collection<TypeParams>,
    userAssignmentFeature: userAssignment.Feature,
    _contexts: contexts.Feature,
  ) =>
    userAssignmentFeature.actions.assignAccess.success.observe().pipe(
      rxjsUtils.latestFrom(
        () => _contexts.selectors.activeEntityContext.asObservable,
      ),
      rxjs.debounceTime(500),
      rxjs.map(context =>
        usersEc.plugins.currentListPlugin.feature.actions.load
          .from('refreshUsersOnAccessAssignmentSuccess (effect)')
          .create(),
      ),
    ),
)
